import React from 'react'

import { TProps as TOptionProps } from 'components/Option'
import { SvgImage } from 'components/SvgImage'

import ChevronRight from 'assets/images/sprite/chevron-right.svg'

import { StyledOptionCard as S } from './OptionCard.styles'

export type TOptionCardProps = TOptionProps & {
  imageUrl: string
  label: string
  $minHeight?: string
  $backgroundColor?: string
  $isCompactLabel?: boolean
  $renderImageAsImg?: boolean
}

export const OptionCard: React.FC<TOptionCardProps> = ({
  imageUrl,
  checked,
  value,
  label,
  $minHeight,
  $backgroundColor,
  $isCompactLabel,
  $renderImageAsImg,
  ...optionProps
}) => (
  <S.Option
    $imageUrl={imageUrl}
    checked={checked}
    value={value}
    $minHeight={$minHeight}
    $backgroundColor={$backgroundColor}
    $renderImageAsImg={$renderImageAsImg}
    {...optionProps}
  >
    {$renderImageAsImg && (
      <S.Image src={imageUrl} alt="" loading="eager" decoding="async" />
    )}

    <S.OptionLabel $isCompact={$isCompactLabel}>
      {label}
      <SvgImage svg={ChevronRight} width={$isCompactLabel ? 16 : 24} />
    </S.OptionLabel>
  </S.Option>
)
